/** Shared fluid layout tokens — use rem/clamp/vw, not fixed px heights on containers */

export const CREAM = '#F5F0E8';
export const TEXT_PRIMARY = CREAM;
export const TEXT_MUTED = CREAM;

export const SECTION_PADDING = 'clamp(2rem, 6vw, 5rem) clamp(1rem, 4vw, 2rem)';

/** Mobile section padding (< 768px) */
export const MOBILE_SECTION_PADDING = '2rem 1rem';

export const SECTION_PADDING_TIGHT = 'clamp(1.25rem, 3vw, 2.5rem) clamp(1rem, 4vw, 2rem)';

export const sectionPadding = (isMobile) =>
  isMobile ? MOBILE_SECTION_PADDING : SECTION_PADDING;

export const sectionPaddingTight = (isMobile) =>
  isMobile ? MOBILE_SECTION_PADDING : SECTION_PADDING_TIGHT;

/** Clears fixed navbar; uses live measured height from Navbar (--dd-navbar-h) */
export const PAGE_TOP_PADDING = 'calc(var(--dd-navbar-h, 5.75rem) + 1.25rem)';

/** Navbar block height fallback — actual value is set on :root by Navbar */
export const NAVBAR_HEIGHT = 'var(--dd-navbar-h, 5.75rem)';

/** Mobile uses the same measured navbar height */
export const PAGE_TOP_PADDING_MOBILE = PAGE_TOP_PADDING;

/** @deprecated Use PAGE_TOP_PADDING_MOBILE — kept for existing imports */
export const PAGE_TOP_PADDING_MOBILE_STACKED = PAGE_TOP_PADDING_MOBILE;

export const NAVBAR_HEIGHT_MOBILE = NAVBAR_HEIGHT;

export const pageTopPadding = (_isMobile) => PAGE_TOP_PADDING;

/** Full page padding with correct fixed-navbar top offset */
export const pagePadding = (isMobile) =>
  `${pageTopPadding(isMobile)} clamp(1rem, 4vw, 2rem) clamp(2rem, 6vw, 3rem)`;

export const HERO_SECTION_PADDING = `clamp(4rem, 12vw, 7rem) clamp(1rem, 4vw, 2rem) clamp(2.5rem, 8vw, 5rem)`;

export const PAGE_PADDING = `clamp(4rem, 12vw, 6rem) clamp(1rem, 4vw, 2rem) clamp(2rem, 6vw, 3rem)`;

export const CARD_PADDING = 'clamp(2rem, 5vw, 4rem) clamp(1rem, 4vw, 2rem)';

export const CONTENT_INSET = 'clamp(0.75rem, 2vw, 1rem)';

export const CONTENT_MAX = '72rem';
export const CONTENT_MAX_WIDE = '80rem';
export const CONTENT_MAX_NARROW = '48rem';
export const CONTENT_MAX_HERO = '42rem';

/** Horizontal inset for full-bleed sections (footer, nav-aligned edges) */
export const SITE_GUTTER = 'clamp(1rem, 5vw, 4rem)';

export const gridMin = (px) => `minmax(min(${px}px, 100%), 1fr)`;

export const gridAutoFit = (px) => `repeat(auto-fit, minmax(min(${px}px, 100%), 1fr))`;

export const gridAutoFill = (px) => `repeat(auto-fill, minmax(min(${px}px, 100%), 1fr))`;
